import {FileConfiguration} from '../../file/message/FileConfiguration';

export class ApiToCtxConfiguration {
cnxCode: string;
engineCode: string;
file: FileConfiguration;
}

